<template>
  <div class="example-code">
    <div class="body">
      <el-container style="height: 100%;">
        <el-aside width="240px">
          <div class="dev_title">
            <span>示例代码</span>
            <div class="all_line"></div>
          </div>
          <el-menu
            :default-active="defaultActive"
            @select="selectMenu"
            class="example-menu">
            <el-menu-item index="1">JAVA调用示例</el-menu-item>
            <!-- <el-menu-item index="2">PHP调用示例</el-menu-item>
            <el-menu-item index="3">.NET调用示例</el-menu-item>
            <el-menu-item index="4">PYTHON调用示例</el-menu-item> -->
          </el-menu>
        </el-aside>
        <el-main class="content-wrapper">
          <div class="dev_title">
            {{titles[defaultActive-1]}}
          </div>
          <div class="code">
            <div style="float: right;position:relative;right: 35px; z-index: 10;">
              <el-button type="text" @click="copyCode">复制</el-button>
            </div>
            <codemirror v-if="defaultActive==='1'" v-model="code1" :options="cmOption1"></codemirror>
            <codemirror v-if="defaultActive==='2'" v-model="code2" :options="cmOption2"></codemirror>
            <codemirror v-if="defaultActive==='3'" v-model="code3" :options="cmOption3"></codemirror>
            <codemirror v-if="defaultActive==='4'" v-model="code4" :options="cmOption4"></codemirror>
          </div>
          <pre id="content">
            {{ content }}
          </pre>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script type="text/babel">
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/go/go.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/vb/vb.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/theme/darcula.css'
import 'codemirror/addon/selection/active-line.js'
import {JAVA_CODE, PHP_CODE, NET_CODE, PYTHON_CODE} from '@/utils/code'
export default {
  components: {
    codemirror
  },
  data: function () {
    return {
      codes: [JAVA_CODE, PHP_CODE, NET_CODE, PYTHON_CODE],
      code1: JAVA_CODE,
      code2: PHP_CODE,
      code3: NET_CODE,
      code4: PYTHON_CODE,
      content: JAVA_CODE,
      models: ['text/x-vb', 'application/x-httpd-php', 'text/x-vb', 'python'],
      // titles: ['JAVA调用示例', 'PHP调用示例', '.NET调用示例', 'PYTHON调用示例'],
      titles: ['JAVA调用示例'],
      defaultActive: '1',
      cmOption1: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-go',
        lineWrapping: true,
        theme: 'darcula'
      },
      cmOption2: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'application/x-httpd-php',
        lineWrapping: true,
        theme: 'darcula'
      },
      cmOption3: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-vb',
        lineWrapping: true,
        theme: 'darcula'
      },
      cmOption4: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'python',
        lineWrapping: true,
        theme: 'darcula'
      }
    }
  },
  name: 'example-code',
  async mounted () {

  },
  methods: {
    selectMenu (index, indexPath) {
      this.defaultActive = index
      this.content = this.codes[this.defaultActive - 1]
    },
    copyCode () {
      const range = document.createRange()
      range.selectNode(document.getElementById('content'))
      const selection = window.getSelection()
      if (selection.rangeCount > 0) selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">
  .example-code{
    background: #F7F7F7;
    overflow: hidden;
    /*height: 2200px;*/
  }
  .example-code .body{
    width: 1200px;
    height: 2200px;
    margin: 60px auto;
    background: #FFFFFF;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
  }

  .example-code .el-main{
    /* height: 2100px; */
    overflow-y: hidden;
  }

  .example-code .el-aside{
    border-right: 1px solid #EBEBEB;
    width: 271px !important;
  }
  .example-code .dev_title{
    padding: 25px 20px;
    font-size: 16px;
    letter-spacing: 1px;
    font-family: MicrosoftYaHei;
    font-weight: 600;
    color: #333333;
  }
  .example-code .dev_title span {
    margin-left: 23px;
	}
	.example-code .dev_title .all_line {
    width: 240px;
    height: 1px;
    margin-top: 22px;
    border-bottom: 1px solid rgba(223,223,223,1);
	}
  .example-code .el-menu-item{
    border-left: 2px solid white;
    padding: 2px 40px!important;
    color: #333333;
    font-weight: 600;
  }
  .example-code .el-menu-item:hover{
    border-left: 2px solid #ECF5FF;
  }
  .example-code .content-wrapper .code{
    margin: 13px 35px 35px 35px;
    width:876px;
    height:2200px;
    border-radius:4px;
  }
  .example-code .content-wrapper .CodeMirror.cm-s-darcula{
    height: 2100px;
    border: 1px solid #EBEBEB;
    background-color: #F7F7F7;
    color:#666666;
  }
  .example-code  .el-menu-item.is-active{
    border-left: 2px solid #108EE9;
    background-color: #ECF5FF;
    color: #108EE9;
  }
  .example-code  .cm-s-darcula.CodeMirror{
    background-color: #F7F7F7;
  }
  .example-code  .CodeMirror-linenumber{
    color:#666666;
  }
  .example-code  .CodeMirror-linenumber.CodeMirror-gutter-elt,
  .example-code .CodeMirror-gutter.CodeMirror-linenumbers{
    background-color: #F7F7F7;
  }
  .example-code .CodeMirror-gutters{
    border-color: #F7F7F7 ;
    margin-right: 18px;
    border-right: 1px solid #F7F7F7!important;
  }
  .example-code .cm-s-darcula span.cm-variable {
    color:#666666!important;
  }
  .example-code .CodeMirror-activeline{
    background-color: #ffffff;
  }
  .example-code .CodeMirror-activeline .CodeMirror-line{
    /*background-color: #ffffff;*/
    background-color: #F7F7F7;
  }
  .example-code .el-button--text{
    color: #108EE9;
  }
  .example-code .el-button{
    padding: 6px 0;
  }
  .example-code .el-container .el-menu{
    border-right: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/example-code/index.vue